// Utils
import { vuelidateUtil } from '@/utils/vuelidate-util.js';

// Components
import DatePicker from 'vue2-datepicker';
import { format } from 'date-fns';

// Mixins
import { dateMixins } from '@/app/mixins/utils/date-mixins';
import { productMixins } from '@/app/mixins/modules/product-mixins.js';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins.js';
import { numberFormatMixins } from '@/app/mixins/modules/number-format-mixins';
import { inputTextMixins } from '@/app/mixins/utils/input-text-mixins';

// Services
import BreedService from '@/app/services/main/breeds/breeds-service';
import PetOrderService from '@/app/services/main/pet-order/pet-order-service.js';
import ProductService from '@/app/services/main/product/product-service';

// Constants
import { STATUS_CODES } from '@/app/constants/constants';

// Event
import EventBus from '@/app/bus/event-bus.js';

export default {
	name: 'DogPurchaseDetails',
	components: {
		DatePicker
	},
	mixins: [
		productMixins,
		toastMessageMixins,
		numberFormatMixins,
		inputTextMixins,
		dateMixins
	],
	data() {
		return {
			isEditAPILoading : false,
			breederRowId:'',
			petDetailsId:'',
			petOrder:'',
			// container
			productEditDetails: null,
			// fields
			userId:'',
			customer:'',
			productName: '',
			requested:false,
			pendingStatus:false,
			forApproval:false,
			viewRequest:false,
			price: '0.00',
			selectTypeIsBreed: true,
			breederId:'',
			breederName:'',
			breederMobile :'',
			breederEmail: '',
			mobileNumberIsValid: true,
			breedId:'',
			birthDate:'',
			gender:'',
			colour:'',
			weight:'',
			notes:'',
			bundleId:'',
			isBreedsAPILoading: false,
			breedList:[],
			genderList: [{name: 'Male', value: 'M'}, {name: 'Female', value: 'F'}],
			updateStatus:"",
			oldData:{}
		}
	},
	computed: {
		validationRules() {
			let fields = {
				productName: {},
			};
			
			const breedFields = {
				breederId:{},
				breederName: {},
				breederMobile:{},
				breederEmail: {},
				gender: {},
				birthDate: {},
				breedId: {},
				price:{},
			};

			const noteField = {
				notes:{}
			}

			fields = vuelidateUtil.setFieldsRequired(fields, true);

			fields = {...fields, ...breedFields};

		
			if(this.selectTypeIsBreed){
				fields = vuelidateUtil.setRequiredValidation(fields, 'selectedProductType');
				fields = vuelidateUtil.setRequiredValidation(fields, 'breederId');
				fields = vuelidateUtil.setRequiredValidation(fields, 'breederName');
				fields = vuelidateUtil.setRequiredValidation(fields, 'breederMobile');
				fields = vuelidateUtil.setRequiredValidation(fields, 'gender');
				fields = vuelidateUtil.setRequiredValidation(fields, 'birthDate');
				fields = vuelidateUtil.setRequiredValidation(fields, 'breedId');
				fields = vuelidateUtil.setRequiredValidation(fields, 'price');
				fields = vuelidateUtil.setMinValueValidation(fields, 'price', 0);
				fields = vuelidateUtil.setEmailValidation(fields, 'breederEmail');
			} 
			
			if (this.updateStatus !== "I") {
				fields = {...fields, ...noteField};
				fields = vuelidateUtil.setRequiredValidation(fields, 'notes');
			}

			return fields;
		},
		isInvalid(){
			if (this.forApproval && !this.requested) {
				return !this.notes != "";
			} else if (this.requested) {
				return this.isValid();
			} else {
				return true;
			}
			
		},
		isInvalidDisapprove(){
			if (this.forApproval && !this.requested) {
				return !this.notes != "";
			} else if (this.requested) {
				return !this.notes != "";
			} else {
				return true;
			}
		},
		compareFields() {
			const {
				oldNotes,
				oldProductName,
				oldPrice,
				oldBirthdate,
				oldColour,
				oldGender,
				oldBreederName,
				oldBreederId,
				oldBreederMobile,
				oldBreederEmail
			} = this.oldData;
			
			// compare
			const compareProductName = oldProductName !== this.productName && this.productName !== "";
			const compareColour = oldColour!== this.colour;
			const compareGender = oldGender!== this.gender.value  && this.gender !== "";
			const compareBreederName = oldBreederName!== this.breederName  && this.breederName !== "";
			const compareBreederId = oldBreederId!== this.breederId && this.breederId !== "";
			const compareBreederMobile = oldBreederMobile!== this.breederMobile.replace('-', '') && this.breederMobile.replace('-', '').length === 10 && this.breederMobile.replace('-', '').length !== 0;
			const compareBreederEmail =  oldBreederEmail!== this.breederEmail && this.breederEmail !== "";
			const compareBirthdate = !this.isSameDay(new Date(oldBirthdate),new Date(this.birthDate)) && this.birthDate !== null;
			const comparePrice = parseFloat(oldPrice) !== parseFloat(this.price) && (parseFloat(this.price) !== parseFloat(0));
			
			let compareNotes;
			
			if (this.updateStatus === 'I') {
				compareNotes = oldNotes !== this.notes;
			} else {
				compareNotes = oldNotes !== this.notes && this.notes !== "";
			}
			
			return !(compareNotes || compareProductName || compareColour || compareBreederId || compareBreederName || compareBreederEmail || compareBreederMobile || comparePrice || compareBirthdate || compareGender );
		},

	},
	created() {
		this.getBreedList();
		this.setFieldsForUpdate();
	},
	watch: {
		'$route': {
			handler() {
				this.setFieldsForUpdate();
			},
			deep: true
		},
	},
	methods: {
		submitDisapprove() {
			this.$swal({
				title: 'Disapprove Dog Purchase',
				text: `Are you sure you want to disapprove this dog purchase of ${this.customer}?`,
				confirmButtonText: 'Confirm',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				reverseButtons: true,
				showCloseButton: true
			})
				.then(result => {
					if (result.value) {
						// API call for reactivate
						this.isAPILoading = true;

						const purchaseDetails = {
							customerId: this.userId,
							status: 'DA',
							note: this.notes,
							expirationDate: format(new Date(), 'yyyy-MM-dd').toString(),
							petDetails: {
								id: this.petDetailsId,
								name: this.productName,
								price: this.price,
								birthdate: this.birthDate,
								colour: this.colour,
								gender: this.gender.value
							},
							breederDetails: {
								id: this.breederRowId,
								breederName: this.breederName,
								breederId: this.breederId,
								breederMobile: this.breederMobile.replace('-', ''),
								breederEmail: this.breederEmail
							}
						}
						
						PetOrderService.putPetPurchase(purchaseDetails,this.petOrder)
							.then(res => {
								if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
									this.showCustomSuccessToast(null, 'Successfully disapproved the purchase request.');
									EventBus.$emit('getDogPurchaseCount');
									this.$router.push(`/dog-purchase`);
								} else {
									this.showAPIErrorToast(null, res);
								}

								this.isAPILoading = false;
							})
							.catch(() => {
								this.showGenericErrorToast();
								this.isAPILoading = false;
							});
					}
				});
		},
		submitApproval() {
			this.$v.$touch();
			if (this.$v.$invalid) {
				return;
			}
			this.$swal({
				title: 'Approve Dog Purchase',
				text: `Are you sure you want to Approve this dog purchase of ${this.customer}?`,
				confirmButtonText: 'Confirm',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				reverseButtons: true,
				showCloseButton: true
			})
				.then(result => {
					if (result.value) {
						this.isAPILoading = true;

						const purchaseDetails = {
							customerId: this.userId,
							status: 'A',
							note: this.notes,
							expirationDate: format(new Date(), 'yyyy-MM-dd').toString(),
							petDetails: {
								id: this.petDetailsId,
								name: this.productName,
								price: this.price,
								birthdate: this.birthDate,
								colour: this.colour,
								gender: this.gender.value
							},
							breederDetails: {
								id: this.breederRowId,
								breederName: this.breederName,
								breederId: this.breederId,
								breederMobile: this.breederMobile.replace('-', ''),
								breederEmail: this.breederEmail
							}
						}

						PetOrderService.putPetPurchase(purchaseDetails,this.petOrder)
							.then(res => {
								if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
									this.showCustomSuccessToast(null, 'Successfully approved the purchase request.');
									EventBus.$emit('getDogPurchaseCount');
									this.$router.push(`/dog-purchase`);
								} else {
									this.showAPIErrorToast(null, res);
								}

								this.isAPILoading = false;
							})
							.catch(() => {
								this.showGenericErrorToast();
								this.isAPILoading = false;
							});
					}
				});
			
		},
		async getBreedList() {
			this.isBreedsAPILoading = true;
			const res = await BreedService.getBreeds();

			if (res.status === STATUS_CODES.SUCCESS) {
				this.breedList = res.data.data;

				
			} 

			this.isBreedsAPILoading = false;
		},
		notPastDate(date) {
			return date > new Date().setHours(0,0,0,0);
		},
		setFieldsForUpdate() {
			if (this.$route.params && this.$route.params.id) {
				this.isEditAPILoading = true;
				if(this.$route.name === "Dog Orders View"){
					this.pendingStatus = true;
					let queryParams = {
						f_id: this.$route.params.id
					}
					PetOrderService.getPetPurchase(queryParams)
						.then(res => {	
							if (res.status === STATUS_CODES.SUCCESS) {
								
								const { orderedby , breed, products, status, note, id, bundleId } = res.data.data[0];
								
								this.bundleId = bundleId;
								
								let bundleInfo = null;
								
								this.updateStatus = status;
								
								if(status === 'P'){
									this.forApproval = true;
								}else{
									this.forApproval = false;
									this.requested = true;
									this.pendingStatus = false;
									this.viewRequest = true;
								}
								products.map(product => { 
									if(product.productType.id === 6) bundleInfo = product;
								});
								
								this.productName = bundleInfo.name;
								
								this.breedId = breed;

								this.customer = orderedby.name;
								this.price = parseFloat(bundleInfo.price);
								this.notes = note;
								this.userId = orderedby.userId;
								this.petOrder = id;
								ProductService.getProductDogById(bundleInfo.id)
									.then(resp => {
										if (resp.status === STATUS_CODES.SUCCESS) {
											const {
												id: petDetailsId,
												birthdate,
												breederId,
												breederName,
												colour,
												gender,
												breedId,
												breederMobile,
												breederEmail,
												breederIdentity,
												name
											} = resp.data;
											
											//mobile number formatting
											let tempMobile = '';

											if (breederMobile) {
												tempMobile = breederMobile.split('');
												tempMobile.splice(4, 0, '-');	
											}
											this.productName = name;
											this.breederRowId = breederIdentity;
											this.petDetailsId = petDetailsId;
											this.birthDate = birthdate ? new Date(birthdate) : birthdate;
											this.breederId = breederId;
											this.breederName = breederName;
											this.breederEmail = breederEmail;
											this.gender = gender === 'M' ? {name: 'Male', value: 'M'} :{name: 'Female', value: 'F'};
											this.colour = colour;
											this.breedId = breedId;
											this.breederMobile = tempMobile.join('');
											
											let breedData =  this.breedList.filter(item => { 
												return item.id === this.breedId;
											});
							
											this.breedId = breedData[0];
											
											this. setOldData();

											this.isEditAPILoading = false;
										} else {
											this.isEditAPILoading = false;
											this.showAPIErrorToast(this.toastMessages.product().ERROR_PRODUCT_FETCH, resp);
										}
									});
								
							} else {
								this.isEditAPILoading = false;
								this.showAPIErrorToast('Unable to fetch product list.', res);
								
							}
						});
				}else{
					
					this.requested = true;
					this.forApproval = true;
					this.pendingStatus = false;
					this.viewRequest = true;

					let queryParams = {
						f_id: this.$route.params.id
					}
					
					PetOrderService.getPetPurchase(queryParams)
						.then(res => {	
							if (res.status === STATUS_CODES.SUCCESS) {
								const { orderedby, status, note } = res.data.data[0];
								this.userId = orderedby.userId;
								this.updateStatus = status;

								if(status !== 'P'){
									this.forApproval = false;
									this.requested = false;
									this.pendingStatus = true;
									this.notes = note;
									this. setOldData();
								}
							} 
						});

					

					PetOrderService.getPetPurchaseByOrderId(this.$route.params.id)
						.then(res => {
							if (res.status === STATUS_CODES.SUCCESS) {
								const { customerName, product: {breederDetails, petDetails, price, name} } = res.data.data;

								const { breederName, breederMobile, breederId, id: breederRowId, breederEmail } = breederDetails;

								const { birthdate, colour, gender, id: petDetailsId } = petDetails;

								let tempMobile = '';

								if (breederMobile) {
									tempMobile = breederMobile.split('');
									tempMobile.splice(4, 0, '-');	
								}
								
								this.petOrder = this.$route.params.id;
								this.breederRowId = breederRowId;
								this.petDetailsId = petDetailsId;
								this.productName = petDetails.name;
								this.customer = customerName;
								this.price = price;
												
								this.birthDate = birthdate ? new Date(birthdate) : birthdate;
								this.breederId = breederId;
								this.breederName = breederName;
								this.gender = gender === 'M' ? {name: 'Male', value: 'M'} :{name: 'Female', value: 'F'};
								this.colour = colour;

								this.breederMobile = tempMobile.join('');
								this.breederEmail = breederEmail;
								this.breedId = {id:'', name};
								
								this. setOldData();
							}
							this.isEditAPILoading = false;
						});
				}
			}
			
		},
		 setOldData(){
			this.oldData = {
				oldNotes: this.notes,
				oldProductName: this.productName,
				oldPrice: this.price,
				oldBirthdate: this.birthDate,
				oldColour: this.colour,
				oldGender: this.gender.value,
				oldBreederName: this.breederName,
				oldBreederId: this.breederId,
				oldBreederMobile: this.breederMobile.replace('-', ''),
				oldBreederEmail: this.breederEmail
			}
		},
		handleBreedListUpdate(breedList) {
			this.breedList = breedList;
		},
		handleBreedListChanges(hasChange) {
			this.hasBreedListChanges = hasChange;
		},
		getAge(dateString) {
			let today = new Date();
			let birthDate = new Date(dateString);
			let age = today.getFullYear() - birthDate.getFullYear();
			let m = today.getMonth() - birthDate.getMonth();
			if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
				age--;
			}
			return age;
		},
		isValid() {
			
			return !( 
				this.productName != '' &&
				this.birthDate != ''  && 
				this.breederId != ''  &&
				this.breederName != ''  &&
				this.price != ''  &&
				this.price != '0.00'  &&
				this.gender != ''  &&
				this.breederMobile != '' &&
				this.notes != '' &&
				this.mobileNumberIsValid
			);
		},
		
		isValidStoreCredit() {
			
			return !( 
				this.productName != '' &&
				this.price != ''  &&
				this.imageUrl != '' &&
				this.selectedProductType != '' &&
				this.selectedProductType != null
			);
		},
		isSameDay(d1, d2) {
			return d1.getFullYear() === d2.getFullYear() 
			&& d1.getDate() === d2.getDate() 
			&& d1.getMonth() === d2.getMonth();
		},
		mobileNumberFormat(event) {
			this.$v.breederMobile.$touch();
			this.mobileNumberIsValid = true;
			
			let regexp = /^\d+$/;
			
			let updateData = regexp.test(event.target.value.charAt(event.target.value.length-1));
			
			if (updateData && event.target.value.length <= 11) {
				if (event.target.value.length === 5) {
					let data = event.target.value.split('');
					if ( event.target.value.charAt(4) === '-' ) {
						data.splice();
					} else {
						data.splice(4, 0, '-');
					}
					data = data.join('');

					this.breederMobile = data;
				} else {
					this.breederMobile = event.target.value;
				}
			} else {
				this.breederMobile= event.target.value.slice(0, -1);
			}
		},
		checkFormat() {
			this.$v.breederMobile.$touch();

			let regexp =  /^\d{4}-\d{6}$/;
			
			if ( this.breederMobile !== null && this.breederMobile !=='' ) {
				this.mobileNumberIsValid = regexp.test(this.breederMobile);
			} else {
				this.mobileNumberIsValid = true;
			}
		},
		updateRequest() {
			if (this.updateStatus !== 'I') {
				this.$v.$touch();
				if (this.$v.$invalid) {
					return;
				}
			}

			this.$swal({
				title: 'Update Dog Purchase',
				text: `Are you sure you want to Update this dog purchase of ${this.customer}?`,
				confirmButtonText: 'Confirm',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				reverseButtons: true,
				showCloseButton: true
			})
				.then(result => {
					if (result.value) {
						this.isAPILoading = true;
						
						const purchaseDetails = {
							isUpdate:true,
							bundleId: this.bundleId,
							customerId: this.userId,
							status: this.updateStatus,
							note: this.notes ? this.notes : "",
							expirationDate: format(new Date(), 'yyyy-MM-dd').toString(),
							petDetails: {
								id: this.petDetailsId,
								name: this.productName,
								price: this.price,
								birthdate: this.birthDate,
								colour: this.colour,
								gender: this.gender.value
							},
							breederDetails: {
								id: this.breederRowId,
								breederName: this.breederName,
								breederId: this.breederId,
								breederMobile: this.breederMobile.replace('-', ''),
								breederEmail: this.breederEmail
							}
						}

						PetOrderService.putPetPurchase(purchaseDetails,this.petOrder)
							.then(res => {
								if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
									this.showCustomSuccessToast(null, 'Successfully update the purchase request.');
									EventBus.$emit('getDogPurchaseCount');
									this. setOldData();
								} else {
									this.showAPIErrorToast(null, res);
								}

								this.isAPILoading = false;
							})
							.catch(() => {
								this.showGenericErrorToast();
								this.isAPILoading = false;
							});
					}
				});
		}
	},
	// third party libraries
	validations() {
		return this.validationRules;
	}
}
